import { render, staticRenderFns } from "./salary-structures.vue?vue&type=template&id=1060c538&"
import script from "./salary-structures.vue?vue&type=script&lang=js&"
export * from "./salary-structures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports